import * as React from 'react';
import CenteredPageContainer from '../../components/CenteredPageContainer';
import NavBar from '../../components/NavBar';
import { Container, Row, Col } from 'reactstrap';
import styled from 'styled-components';

const FAQLink = styled.a`
  color: #00144d;
  :hover {
    color: #334371;
  }
`;

const FAQPage = () => {
  return (
    <CenteredPageContainer>
      <NavBar />
      <Container style={{ marginTop: 25 }}>
        <Row>
          <Col xs={{ size: 12 }} md={{ size: 6, offset: 3 }}>
            <h5>How does StoreWith work?</h5>
            <p>
              StoreWith is Airbnb for college storage. You put in your address, number of boxes, and
              basic contact information, and our algorithm matches you with a student host living
              off-campus.
            </p>
            <br />
            <h5>
              How is StoreWith any different from storage solutions like Storage Squad and School
              Storage?
            </h5>
            <p>
              StoreWith is the cheapest option by a landslide — our customers save more than $100 on
              average on summer storage, and we're the only storage service to provide insurance on
              all your items. We're also huge advocates of transparent pricing. The price you see at
              checkout is exactly what you'll pay, and you'll never incur hidden fees or unexpected
              charges.
            </p>
            <br />
            <h5>What about the safety of my items?</h5>
            <p>
              We personally vet every host on platform to ensure the safety of your items. On top of
              this we provide a $100 insurance guarantee per box, in the rare event something goes
              wrong. For more information, you can check out our{' '}
              <FAQLink href="https://storewithpenn.com/terms-of-service" target="_blank">
                Terms of Service
              </FAQLink>
              .
            </p>
            <br />
            <h5>How do I become a Host?</h5>
            <p>
              Sign up on our <FAQLink href="/become-a-host">Host Form</FAQLink>. We'll be in touch
              within 24 hours, and will then proceed to personally vet your home for insurance,
              location, cleanliness, and a set of other factors to ensure the quality of our hosts.
            </p>
            <br />
            <h5>How much can I make as a Host?</h5>
            <p>
              Our hosts make on average $130 per student that stores with them, but that number can
              be higher depending on the number of boxes and items that a student chooses to store.
            </p>
            <br />
            <h5>How do I know if my space is a good fit for StoreWith?</h5>
            <p>
              As long as you have free space that you will own for the duration of storage, you're
              eligible to host students with us.
            </p>
            <br />
            <h5>Is there a cancellation fee?</h5>
            <p>No, we do not charge a cancellation fee.</p>
            <br />
            <h5>How are payments handled?</h5>
            <p>
              Students pay via credit card. All our transactions are conducted via{' '}
              <FAQLink href="https://stripe.com" target="_blank">
                Stripe
              </FAQLink>
              , and hosts are paid via{' '}
              <FAQLink href="https://venmo.com" target="_blank">
                Venmo
              </FAQLink>
              . We take security seriously, and will never store your payment information on our
              site.
            </p>
            <br />
            <h5>Do you have a privacy policy?</h5>
            <p>
              Yes, we do happen to have a privacy policy. You can find it{' '}
              <FAQLink
                href="https://drive.google.com/file/d/14iAL1C3-RcCo8adwVpHhRthWJDRYXVyw/view"
                target="_blank"
              >
                here
              </FAQLink>
              .
            </p>
            <br />
            <h5>Do you have a Terms of Service?</h5>
            <p>
              Yes, we do happen to have a Terms of Service. You can find it{' '}
              <FAQLink
                href="https://drive.google.com/file/d/1mgOn88ZCeDsSflycibQ32TGQZHI9r30E/view"
                target="_blank"
              >
                here
              </FAQLink>
              .
            </p>
          </Col>
        </Row>
      </Container>
    </CenteredPageContainer>
  );
};

export default FAQPage;



// WEBPACK FOOTER //
// ./src/pages/FAQPage/FAQPage.tsx